module.exports = __webpack_public_path__ + "static/media/project-c.81798724.jpg";